// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.manual-demo .dz-image img {\n  width: auto !important;\n  height: auto !important;\n  -o-object-fit: fill !important;\n     object-fit: fill !important;\n}\n", ""]);
// Exports
module.exports = exports;
